import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  CardContent,
  Grid,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { Card } from "react-bootstrap";

const OrderDetails = () => {
  const [details, setDetails] = useState({});
  const location = useLocation();
  const { id } = location.state;
  console.log(id);
  const orderDetails = async () => {
    try {
      const res = await axios.get(
        `http://api.meddaily.in/order_details?order_id=${id}`,
        {
          headers: {
            token: sessionStorage.getItem("token"),
          },
        }
      );
      if (res.status === 200) {
        setDetails(res.data.data);
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    orderDetails();
  }, []);
  const formatCreatedAt = (createdAt) => {
    const date = new Date(createdAt);
    return date.toLocaleString();
  };
  console.log(details);
  console.log(details.payment_type);
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Sidebar />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Navbar />
            </Grid>
            <Grid item xs={11}>
              <Typography
                variant="h4"
                gutterBottom
                align="center"
                sx={{ marginTop: "15px" }}
              >
                Order Details
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    Order ID: {details.order_id}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Created At: {formatCreatedAt(details.createdAt)}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Distributor Name: {details.distributor_name}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Address: {details.distributor_address}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Retailer Name: {details.retailer_name}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Address: {details.retailer_address}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Order Status: {details.order_status === 0 && "Cancelled"}
                    {details.order_status === 1 && "Order Shipeed"}
                    {details.order_status === 3 && "Order Delivered"}
                    {details.order_status === 4 && "Order Placed"}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Payment Type: {details.payment_type === "1" && "COD"}
                    {details.payment_type === "2" && "Pay On Credit"}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Total Price: {details.item_total}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Payment Status: {details.payment_status}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card>
                {details.products &&
                  details.products.map((item, ind) => {
                    return (
                      <div key={ind} style={{ display: "flex", gap: "80px" }}>
                        <span>Name: {item.name}</span>
                        <span>Batch No: {item.batch_no}</span>
                        <span>Exp Date: {item.exp_date}</span>
                        <span>Price: {item.price}</span>
                        <span>Quantity: {item.quantity}</span>
                      </div>
                    );
                  })}
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default OrderDetails;
